import React from 'react';

// Styles & Assets
import styles from './SliderCheckbox.module.css';

// SliderCheckbox: component that renders a slider checkbox. 
// Ex: In the patients Toolbar to select the Sonar view.
//  -checked: indicates whether the checkbox is checked.
//  -handleChange: handles the change on a click
//  -label: label on the right of the slider.
const SliderCheckbox: React.FC<{
    checked?: boolean,
    defaultChecked?: boolean,
    handleChange: React.ChangeEventHandler<HTMLInputElement>,
    label: string,
}> = ({ checked, handleChange, label, defaultChecked }) => {

    return (
        <div className={styles.switchContainer}>
            <label className={styles.switch}>
                <input type="checkbox" checked={checked} defaultChecked={defaultChecked} onChange={handleChange} />
                <div className={`${styles.slider} ${styles.round}`}></div>
            </label>
            <p className={styles.label}>{label}</p>
        </div>
    );
};

export default SliderCheckbox;